import { expectedErrorsConfig } from './config'

export { expectedErrorsConfig } from './config'

/**
 * Extracts the domain segment from the current URL pathname.
 *
 * URL patterns:
 *   /partners/:id/warehouses/:id/<domain>/...  (retailer-scoped)
 *   /partners/:id/<domain>/...                 (partner-scoped)
 *   /admin/<domain>/...                        (admin)
 *   /app/admin/<domain>/...                    (app-admin, e.g. massops)
 */
export function getDomainFromPathname(pathname?: string): string | undefined {
  const path = pathname ?? window?.location?.pathname
  if (!path) return undefined

  const segments = path.replace(/^\//, '').split('/')

  // /partners/:id/warehouses/:id/<domain>
  if (segments[0] === 'partners' && segments[2] === 'warehouses' && segments.length > 4) {
    return segments[4]
  }

  // /partners/:id/<domain>
  if (segments[0] === 'partners' && segments.length > 2) {
    return segments[2]
  }

  // /app/admin/<domain>
  if (segments[0] === 'app' && segments[1] === 'admin' && segments.length > 2) {
    return segments[2]
  }

  // /admin/<domain>
  if (segments[0] === 'admin' && segments.length > 1) {
    return segments[1]
  }

  return undefined
}

function matchesRule(
  code: string,
  operationName: string | undefined,
  rule: { code?: string; codePattern?: RegExp; operationPattern?: RegExp }
): boolean {
  // Must match at least one code criterion
  const codeMatches = rule.code ? rule.code === code : (rule.codePattern?.test(code) ?? false)
  if (!codeMatches) return false
  if (rule.operationPattern && (!operationName || !rule.operationPattern.test(operationName))) {
    return false
  }
  return true
}

export function isExpectedError(
  code: string | undefined,
  operationName?: string,
  domain?: string
): boolean {
  if (!code) return false

  if (expectedErrorsConfig.common.some(rule => matchesRule(code, operationName, rule))) {
    return true
  }

  const resolvedDomain = domain ?? getDomainFromPathname()
  const domainRules = resolvedDomain ? expectedErrorsConfig.byDomain[resolvedDomain] : undefined
  if (domainRules) {
    if (domainRules.some(rule => matchesRule(code, operationName, rule))) {
      return true
    }
  }

  return false
}
